export default __webpack_public_path__ + "static/media/topright.fae8b9ae.png";